import { render, staticRenderFns } from "./checkUpResultDetail.vue?vue&type=template&id=ab0fb65c"
import script from "./checkUpResultDetail.vue?vue&type=script&lang=js"
export * from "./checkUpResultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab0fb65c')) {
      api.createRecord('ab0fb65c', component.options)
    } else {
      api.reload('ab0fb65c', component.options)
    }
    module.hot.accept("./checkUpResultDetail.vue?vue&type=template&id=ab0fb65c", function () {
      api.rerender('ab0fb65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpResultDetail.vue"
export default component.exports